import React from 'react';
import NumberInput from '../../../../../Components/Form/Inputs/NumberInput';
import RegexValidators from '../../../../../Core/Validation/RegexValidators';
import useLanguage from '../../../../../Services/Language/useLanguageHook';
import styles from '../DairyRevenueProtection.module.scss';
import { DairyRevenueProtectionCalculationInputs } from '../DairyRevenueProtectionDefinitions';

interface IDairyRevenueProtectionDeclaredProductionInputProps {
    calculationInputs: DairyRevenueProtectionCalculationInputs;
    setCalculatorInputs: (value: DairyRevenueProtectionCalculationInputs) => void;
}

const DairyRevenueProtectionDeclaredProductionInput: React.FC<IDairyRevenueProtectionDeclaredProductionInputProps> = (
    props: IDairyRevenueProtectionDeclaredProductionInputProps,
) => {
    const [translations] = useLanguage();

    return (
        <div className={styles.dairy_revenue_protection_max_fit_content}>
            <NumberInput
                title={translations.risk.margin.fields.declaredCoveredMilkProduction}
                required
                value={props.calculationInputs?.declaredMilkProduction}
                validation={RegexValidators.PositiveNumber}
                handleTextChange={(value) => props.setCalculatorInputs({ ...props.calculationInputs!, declaredMilkProduction: +value })}
                errorMessage={translations.marketIndicatorsManagement.messages.positiveNumber}
                track={{
                    eventCategory: 'InsuranceQuoteEstimator',
                    eventAction: 'DairyDeclaredMilkProductionChanged',
                    eventValue: props.calculationInputs?.declaredMilkProduction,
                }}
            />
        </div>
    );
};

export default DairyRevenueProtectionDeclaredProductionInput;
